import clsx from "clsx"

import {
  FullScreenImage as FullScreenImageAbstract,
  type FullScreenImageProps as FullScreenImageAbstractProps,
} from "@unlikelystudio/react-abstract-components"

import CloseButton from "~/components/ui/CloseButton"
import { Image, type ImageProps } from "~/components/ui/Image"
import Icon from "~/components/abstracts/Icon"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"

import { sprinkles } from "~/styles/sprinkles.css"

import * as css from "./styles.css"

export interface FullScreenImageProps extends FullScreenImageAbstractProps {
  imageProps?: ImageProps
}

function FullScreenImage({ className, imageProps, ...props }: FullScreenImageProps) {
  const t = useTranslate()

  return imageProps ? (
    <FullScreenImageAbstract
      classes={{
        FullScreenImage: clsx(className, css.FullScreenImage),
        controlsContainer: clsx(css.controlsContainer, sprinkles({})),
        controls: clsx(css.controls),
        fullScreenImageContainer: clsx(css.fullScreenImageContainer),
        placeholder: clsx(css.placeholder),
      }}
      imageWidth={imageProps.width}
      imageHeight={imageProps.height}
      image={<Image className={clsx(css.placeholder)} imageClassName={clsx(css.image)} asPlaceholder {...imageProps} />}
      previousComponent={
        <button aria-label={t("aria_arrow_prev")}>
          <Icon className={clsx(css.icon)} name="Arrow" direction="left" />
        </button>
      }
      nextComponent={
        <button aria-label={t("aria_arrow_next")}>
          <Icon className={clsx(css.icon)} name="Arrow" direction="right" />
        </button>
      }
      closeComponent={<CloseButton />}
      {...props}
    />
  ) : null
}

export default FullScreenImage
